export default __webpack_public_path__ + "static/media/profileImage.b15814a4.jpg";